export default __webpack_public_path__ + "static/media/photo10.ff91fe2b.jpg";